<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Trash from '$icons/TrashIcon.svelte';
  import EditLabel from '$lib/components/common/inputs/textInputs/editableLabels/EditLabel.svelte';
  import GlobalTextInput from '../GlobalTextInput.svelte';

  export let value;
  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let deleteable: boolean = false;

  const dispatch = createEventDispatcher();

  $: {
    value, label;
    dispatch('change', { value, label });
  }
</script>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-garden-grey-600 font-medium text-sm flex flex-row justify-between w-full" for="">
    {#if label}
      {#if label === 'Total hours' || label === 'Daily avg hours'}
        <div class="flex flex-row items-center gap-1">
          {label}
        </div>
      {:else}
        <EditLabel bind:label on:labelChange />
      {/if}

      <button
        class:hidden={!deleteable}
        class="cursor-pointer"
        on:keydown
        on:click={() => {
          dispatch('delete');
        }}
      >
        <Trash size={20} color="#CA2140" />
      </button>
    {:else}&nbsp;{/if}
  </label>

  <GlobalTextInput bind:value {danger} {dangerMessage} {caption} {placeholder} on:submit/>
</div>
